import React, { useEffect } from 'react';
import { Button, Form, Input, message, Modal, Upload} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const CountryForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(record);
  }, [record, form]);

  
  // File validation for image upload
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    if (e && e.fileList) {
      return e.fileList;
    }
    return [];
  };

  const uploadProps = {
    beforeUpload: (file) => {
      const isPNG = file.type === 'image/png';
      const isJPG = file.type === 'image/jpeg';
      if (!isPNG && !isJPG) {
        message.error(`${file.name} is not a png/jpeg file`);
      }
      return isPNG || isJPG || Upload.LIST_IGNORE;
    },
    onChange: (info) => {
      console.log(info.fileList);
    },
    maxCount: 1,
  };


  return (
    <Modal
      visible={visible}
      title={record ? "Update Country" : "Add Country"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onCreate(values);
            form.resetFields();
          })
          .catch(info => {
            console.log('Validate Failed:', info);
          });
      }}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="product_form"
        initialValues={record}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the product name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="code"
          label="Code"
          rules={[{ required: true, message: 'Please enter the product code!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="nationality"
          label="Nationality"
          rules={[{ required: true, message: 'Please enter the product nationality!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="file" label="Image" valuePropName="fileList" getValueFromEvent={normFile} extra="Only one image file (PNG/JPG) is allowed.">
          <Upload {...uploadProps} listType="picture" accept=".png,.jpg,.jpeg">
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CountryForm;
//   const [form] = Form.useForm();

//   // Set initial values when the record changes
//   React.useEffect(() => {
//     form.setFieldsValue(record);
//   }, [record, form]);

//   return (
//     <Modal
//       visible={visible}
//       title={record ? "Update Product" : "Add Product"}
//       okText="Submit"
//       cancelText="Cancel"
//       onCancel={onCancel}
//       onOk={() => {
//         form
//           .validateFields()
//           .then(values => {
//             onCreate(values);
//             form.resetFields();
//           })
//           .catch(info => {
//             console.log('Validate Failed:', info);
//           });
//       }}
//     >
//       <Form
//         form={form}
//         layout="vertical"
//         name="product_form"
//         initialValues={record}
//       >
//         <Form.Item
//           name="name"
//           label="Name"
//           rules={[{ required: true, message: 'Please enter the product name!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="brandName"
//           label="Brand"
//           rules={[{ required: true, message: 'Please enter the brand name!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="modelName"
//           label="Model"
//           rules={[{ required: true, message: 'Please enter the model name!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="seriesName"
//           label="Series"
//           rules={[{ required: true, message: 'Please enter the series name!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="color"
//           label="Color"
//           rules={[{ required: true, message: 'Please enter the color!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="price"
//           label="Price"
//           rules={[{ required: true, message: 'Please enter the price!' }]}
//         >
//           <InputNumber min={0} style={{ width: '100%' }} />
//         </Form.Item>
//         <Form.Item
//           name="storage"
//           label="Storage"
//           rules={[{ required: true, message: 'Please enter the storage!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="network"
//           label="Network"
//           rules={[{ required: true, message: 'Please enter the network!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="osNo"
//           label="OS"
//           rules={[{ required: true, message: 'Please enter the OS!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item
//           name="inStock"
//           label="In Stock"
//           valuePropName="checked"
//         >
//           <Input type="checkbox" />
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// };

// export default ProductsForm;